import axios from "axios"
import { ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes"
import configData from "config.json"
import { authHeader, authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header"
import { hadleAxiosErrorResponse } from "helpers/handle-response"
import { InfoPersonasHE } from "../Asignar numero CUR/typesAsignarCur"
import { AprobarSolicitudesHEDTO, DetalleRegimenLaboralHEDTO, solicitudesUnidad } from "./typesAprobarSolicitudHE"
import { UserData } from "components/Sidebar/Sidebar_Principal"
import { authenticationService } from "services/authentication.service"
import { downloadExcelReport } from "helpers/downloadExcelReport"
import { InfoDoc } from "../Revision Documento Pago Horas Extras/typesDocumentoPagoEspolHE"


const URL_CONTROLLER_APROBACIONES_TH = `${configData.SERVER_URL}AprobacionSolicitudesTH`

const URL_PLANIFICACION_REGIMEN = `${URL_CONTROLLER_APROBACIONES_TH}/PlanificacionRegimen/`

const URL_INFORMACION_SOLICITUDES = `${URL_CONTROLLER_APROBACIONES_TH}/InformacionSolicitudHE/`

const URL_NUMERO_SOLICITUDES_UNIDAD = `${URL_CONTROLLER_APROBACIONES_TH}/UnidadNumeroSolicitudes/`

export async function obtenerInfoRegimenPlan(mes: number, anio: number, id: number) {
    var respuesta: ResponseRequestGeneric<DetalleRegimenLaboralHEDTO[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_PLANIFICACION_REGIMEN}${mes}/${anio}/${id}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: DetalleRegimenLaboralHEDTO[] | undefined = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }

    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleRegimenLaboralHEDTO[]>(error)
    }
    return respuesta

}

export async function obtenerInfoSolicitudes(desde: string, hasta: string, id: number) {
    var respuesta: ResponseRequestGeneric<AprobarSolicitudesHEDTO[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_INFORMACION_SOLICITUDES}${desde}/${hasta}/${id}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: AprobarSolicitudesHEDTO[] | undefined = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }

    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<AprobarSolicitudesHEDTO[]>(error)
    }
    return respuesta

}

export async function obtenerMesesAprob(desde: string, hasta: string) {
    var respuesta: ResponseRequestGeneric<string[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_APROBACIONES_TH}/ObtenerMeses/${desde}/${hasta}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<string[]>(error)
    }
    return respuesta
}

export async function obtenerNumSolicitudesUnidad(desde: string, hasta: string) {
    var respuesta: ResponseRequestGeneric<solicitudesUnidad[]> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_NUMERO_SOLICITUDES_UNIDAD}${desde}/${hasta}`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: solicitudesUnidad[] | undefined = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }

    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<solicitudesUnidad[]>(error)
    }
    return respuesta

}

export async function VistaPreviaSolicitudHETHoUsuario(idSolicitud: number, tipo: "NOMINA" | "DIRECTIVO") {
    var url: string = "";
    if (tipo == "NOMINA") {
        url = `${URL_CONTROLLER_APROBACIONES_TH}/VistaPreviaSolicitudHorasExtrasNominaTH/${idSolicitud}`;
    }
    else if (tipo == "DIRECTIVO") {
        url = `${URL_CONTROLLER_APROBACIONES_TH}/VistaPreviaSolicitudHorasExtrasUsuario/${idSolicitud}`;
    }

    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<string> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario),
                responseType: "blob"
            }
        )

        let urFormulario = window.URL.createObjectURL(respuesta.data);
        infoResponse = { status: respuesta.status, dataResponse: urFormulario }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
            infoResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }
    return infoResponse;
}
export async function FirmarEnviarSolicitudNominaTH(solicitud: AprobarSolicitudesHEDTO) {
    const url = `${URL_CONTROLLER_APROBACIONES_TH}/FirmarSolicitudNominaTH`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url, solicitud,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        infoResponse = {
            status: respuesta.status
        }


    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}

export async function EnvioSolicitudRechazada(idsolicitud: number, observacion: any) {
    const url = `${URL_CONTROLLER_APROBACIONES_TH}/RechazoSolicitudNominaTH/${idsolicitud}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url, observacion,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )

        infoResponse = {
            status: respuesta.status,
            dataResponse: respuesta.data
        }


    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}

export async function FirmaTodasSolicitudesNominaTH(solicitudes: AprobarSolicitudesHEDTO[]) {
    const url = `${URL_CONTROLLER_APROBACIONES_TH}/FirmarTodasSolicitudesNominaTH`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url, solicitudes,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        infoResponse = {
            status: respuesta.status
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}
export async function VistaPreviaHojaMarcaciones(idSolicitud: number) {
    const url = `${URL_CONTROLLER_APROBACIONES_TH}/VistaPreviaHojaMarcaciones/${idSolicitud}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<string> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario),
                responseType: "blob"
            }
        )

        let urFormulario = window.URL.createObjectURL(respuesta.data);
        infoResponse = { status: respuesta.status, dataResponse: urFormulario }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
            infoResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }
    return infoResponse;
}

export async function VistaPreviaPagoEspol(desde: string, hasta: string) {
    const url = `${URL_CONTROLLER_APROBACIONES_TH}/VistaPreviaDocumentoPagoEspol/${desde}/${hasta}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<string> = { status: -1 }
    try {
        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario),
                responseType: "blob"
            }
        )

        let urFormulario = window.URL.createObjectURL(respuesta.data);
        infoResponse = { status: respuesta.status, dataResponse: urFormulario }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
            infoResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }
    return infoResponse;
}
export async function EnvioInfoDocPagoEspol(objeto: any, mes: number, anio: number, desde: string, hasta: string) {
    const url = `${URL_CONTROLLER_APROBACIONES_TH}/CreacionDocumentoPagoEspol/${mes}/${anio}/${desde}/${hasta}`;
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var infoResponse: ResponseRequestGeneric<void> = { status: -1 }
    try {
        const respuesta = await axios.post(url, objeto,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        infoResponse = {
            status: respuesta.status
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = hadleAxiosErrorResponse<void>(error)
        }
    }
    return infoResponse;
}

export async function GuardarDocumentoSolicitudPE(datosRequest: FormData) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleSolicitudesAprobadasHEDTO: AprobarSolicitudesHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleSolicitudesAprobadasHEDTO }


    const url = `${URL_CONTROLLER_APROBACIONES_TH}/FirmaDocPagoEspol`;
    try {
        const respuesta = await axios.post(url, datosRequest, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleSolicitudesAprobadasHEDTO = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleSolicitudesAprobadasHEDTO,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function ObtenerReporteExcelSolAprob(desde: string, hasta: string) {
    var respuesta: ResponseRequestGeneric<string> = {
        status: -1
    }
    const url = `AprobacionSolicitudesTH/ReporteSolicitudesAprobadas/${desde}/${hasta}`;
    try {
        const responseAxios = await axios.get(`${configData.SERVER_URL}`+url, {
            headers: authHeader()
        })
        var data: InfoDoc | undefined = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }
        await downloadExcelReport(url, "REPORTE SOLICITUDES APROBADAS.xlsx");
    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<string>(error)
    }
    return respuesta;
}

export async function ObtenerDocGuardado() {
    var respuesta: ResponseRequestGeneric<InfoDoc | null> = {
        status: -1
    }
    try {
        const URL_COMPLETA = `${URL_CONTROLLER_APROBACIONES_TH}/DocumentoPrimeraFirma`;
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: InfoDoc | undefined = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: responseAxios.data
        }

    }
    catch (error) {
        respuesta = hadleAxiosErrorResponse<InfoDoc | null>(error)
    }
    return respuesta
}